module.exports = __webpack_public_path__ + "img/a2-s51.e208034c.jpg";